import { useState } from "react";
import AddNew from "./AddNew";
import List from "./List";
import startOfToday from "date-fns/esm/startOfToday/index.js";
import AllyInfo from "./AllyInfo";
import AllyFilter from "./AllyFilter";


export default function Allies() {
    const [day, setDay] = useState<Date>(startOfToday())
    const [endDay, setEndDay] = useState<Date>()
    const [allyId, setAllyId] = useState<string>()
    return (
        <>
            <AddNew/>
            <AllyFilter
            day={day}
            setDay={setDay}
            endDay={endDay}
            setEndDay={setEndDay}
            setAllyId={setAllyId}
            />
            {
                allyId &&
                <AllyInfo
                day={day}
                endDay={endDay}
                id={allyId}
                />
            }
            <List/>
        </>
    )
}